/* Pet Flow 35 — non-hero page interactions. Hero/gallery/cart logic lives in pf35-grass-hero.js. */
document.querySelectorAll('.pf-faq-q').forEach(b=>b.addEventListener('click',()=>b.parentElement.classList.toggle('open')));
document.querySelectorAll('[data-tab]').forEach(btn=>btn.addEventListener('click',()=>{document.querySelectorAll('[data-tab]').forEach(b=>b.classList.toggle('active',b===btn));document.querySelectorAll('[data-panel]').forEach(p=>p.hidden=p.dataset.panel!==btn.dataset.tab)}));
document.querySelectorAll('[data-tech]').forEach(btn=>btn.addEventListener('click',()=>document.querySelectorAll('[data-tech]').forEach(b=>b.classList.toggle('active',b===btn))));

function pfInstallExactApprovedBackground(){
  const hero=document.querySelector('[data-pf-approved-background]');
  if(!hero) return;

  const backgroundUrl=hero.dataset.pfApprovedBackground;
  if(!backgroundUrl) return;

  const main=
    hero.closest('#MainContent') ||
    hero.closest('main') ||
    document.querySelector('#MainContent') ||
    document.querySelector('main');

  if(!main) return;

  /* Clear every theme wrapper between each Pet Flow section and main.
     This prevents theme colour/gradient wrappers from hiding the pattern. */
  document.querySelectorAll('.pf-shopify-section').forEach((section)=>{
    section.style.setProperty('background-color','transparent','important');
    section.style.setProperty('background-image','none','important');

    let node=section.parentElement;
    while(node && node!==main){
      node.style.setProperty('background-color','transparent','important');
      node.style.setProperty('background-image','none','important');
      node=node.parentElement;
    }
  });

  main.style.setProperty('position','relative','important');
  main.style.setProperty('background-color','#fbf3e6','important');
  main.style.setProperty(
    'background-image',
    `url("${backgroundUrl}"), linear-gradient(180deg,#fffaf0 0,#f8ecd9 46%,#fff8ec 100%)`,
    'important'
  );
  main.style.setProperty('background-repeat','repeat, no-repeat','important');
  main.style.setProperty('background-size','1100px 820px, 100% 100%','important');
  main.style.setProperty('background-position','0 0, 0 0','important');
  main.style.setProperty('background-attachment','scroll, scroll','important');
}

if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',pfInstallExactApprovedBackground,{once:true});
}else{
  pfInstallExactApprovedBackground();
}

/* Re-apply after Shopify Theme Editor section reloads/reorders. */
document.addEventListener('shopify:section:load',pfInstallExactApprovedBackground);
document.addEventListener('shopify:section:reorder',pfInstallExactApprovedBackground);
